module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "pvi"
    }
  }), _c('a', {
    attrs: {
      "id": "pvii"
    }
  }), _vm._v(" "), _c('blockquote', {
    staticClass: "sink"
  }, [_c('p', {
    staticClass: "center "
  }, [_vm._v("Glory Days, well, they’ll pass you by.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("—"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BRUCE SPRINGSTEEN,")]), _c('br'), _vm._v(" from "), _c('em', [_vm._v("Born in the U.S.A.,")]), _vm._v(" released June 4, 1984")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }, [_c('hr', {
    staticClass: "context "
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "spaceabove1"
  }, [_c('p', {
    staticClass: "center "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REPORTER:")]), _vm._v(" “Is it true you can fly?”")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MICHAEL JORDAN:")]), _vm._v(" “No. Well, maybe for a little.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-134c44ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front03.vue
// module id = 69
// module chunks = 0